/** Takes a stable snapshot instead of reading mutable globals during selection. */
export function detectHostCapabilities(canvas, environment = globalThis) {
    return {
        crossOriginIsolated: environment.crossOriginIsolated === true,
        offscreenCanvas: typeof environment.OffscreenCanvas === "function",
        sharedArrayBuffer: typeof environment.SharedArrayBuffer === "function",
        transferableCanvas: typeof canvas.transferControlToOffscreen === "function",
        worker: typeof environment.Worker === "function",
    };
}
/** Applies the ADR-0001 SAB → postMessage → main-thread fallback chain. */
export function selectHostTransport(capabilities, policy = {}) {
    const requested = policy.preference ?? "auto";
    const reasons = [];
    const workerEnabled = policy.globalWorkerEnabled !== false &&
        policy.deviceWorkerEnabled !== false &&
        policy.pageWorkerEnabled !== false;
    const workerCapable = capabilities.worker && capabilities.offscreenCanvas && capabilities.transferableCanvas;
    if (requested === "main-thread") {
        return decision(capabilities, requested, "main-thread", ["main-thread explicitly requested"]);
    }
    if (!workerEnabled) {
        return decision(capabilities, requested, "main-thread", ["Worker disabled by policy"]);
    }
    if (!workerCapable) {
        if (!capabilities.worker)
            reasons.push("Worker unavailable");
        if (!capabilities.offscreenCanvas)
            reasons.push("OffscreenCanvas unavailable");
        if (!capabilities.transferableCanvas)
            reasons.push("canvas is not transferable");
        return unavailable(capabilities, policy, requested, "main-thread", reasons);
    }
    const sabCapable = capabilities.crossOriginIsolated && capabilities.sharedArrayBuffer;
    if (requested === "post-message") {
        return decision(capabilities, requested, "post-message", ["postMessage explicitly requested"]);
    }
    if (requested === "sab" && !sabCapable) {
        if (!capabilities.crossOriginIsolated)
            reasons.push("cross-origin isolation unavailable");
        if (!capabilities.sharedArrayBuffer)
            reasons.push("SharedArrayBuffer unavailable");
        return unavailable(capabilities, policy, requested, "post-message", reasons);
    }
    if (sabCapable) {
        return decision(capabilities, requested, "sab", ["SAB Worker path available"]);
    }
    if (!capabilities.crossOriginIsolated)
        reasons.push("cross-origin isolation unavailable");
    if (!capabilities.sharedArrayBuffer)
        reasons.push("SharedArrayBuffer unavailable");
    reasons.push("using bounded postMessage fallback");
    return decision(capabilities, requested, "post-message", reasons);
}
function unavailable(capabilities, policy, requested, fallback, reasons) {
    if (policy.strict === true) {
        throw new Error(`${requested} transport is unavailable: ${reasons.join(", ")}`);
    }
    reasons.push(`falling back to ${fallback}`);
    return decision(capabilities, requested, fallback, reasons);
}
function decision(capabilities, requested, mode, reasons) {
    return { capabilities, mode, reasons: [...reasons], requested };
}
//# sourceMappingURL=capabilities.js.map